<template>
    <div class="container bng-virtual-sports bng-narrow-container">
        <jackpots-bar v-if="jackpots && jackpots.length"/>
        <game-list v-if="games" :games="games" />
    </div>
</template>
<script>
import Vue from "vue";

import GameList from '../../../common/game-list/game-list.vue';
import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';

export default {
    name: 'virtual-sports',
    components: { GameList, JackpotsBar },
    data() {
        return {
            games: null
        };
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (
                (this.player &&
                    this.player.balance &&
                    this.player.activeJackpots) ||
                []
            );
        }
    },
    created() {
        this.games = Vue.state.games.get().categories.find(c => c.name == 'virtual-sports').games;
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sports.vue